import { SurveyItemRaw } from "./reports-page-types"

interface SurveyItemNormalized {
  question: string
  total: number
  answers: Record<string, number>
}

export function parseAnswers(raw: string): Record<string, number> {
  const result: Record<string, number> = {}
  raw.split(";").forEach((pair) => {
    const trimmed = pair.trim()
    const lastColon = trimmed.lastIndexOf(":")
    if (lastColon === -1) return
    const key = trimmed.slice(0, lastColon).trim()
    const val = parseInt(trimmed.slice(lastColon + 1).trim(), 10)
    if (key && !isNaN(val)) {
      result[key] = val
    }
  })
  return result
}

export function normalizeData(data: SurveyItemRaw[]): SurveyItemNormalized[] {
  return data.map((item) => ({
    question: item.question,
    total: item.total,
    answers: typeof item.answers === "string" ? parseAnswers(item.answers) : item.answers,
  }))
}
